/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignsIndex } from '../../axios/campaignsIndex'
import type { CampaignsIndexError, CampaignsIndexQueryParams, CampaignsIndexResponse } from '../../types/CampaignsIndex'

export const campaignsIndexQueryKey = (params?: CampaignsIndexQueryParams) =>
	[{ url: '/campaigns' }, ...(params ? [params] : [])] as const

export type CampaignsIndexQueryKey = ReturnType<typeof campaignsIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::index */
export function campaignsIndexQueryOptions(params?: CampaignsIndexQueryParams, config?: AxiosRequestConfig) {
	return queryOptions<
		CampaignsIndexResponse,
		AxiosError<CampaignsIndexError>,
		CampaignsIndexResponse,
		CampaignsIndexQueryKey
	>({
		queryKey: campaignsIndexQueryKey(params),
		queryFn: ({ signal }) => campaignsIndex(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::index */
export function useCampaignsIndex<TSelectData = CampaignsIndexResponse>(
	params?: CampaignsIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CampaignsIndexResponse,
					AxiosError<CampaignsIndexError>,
					TSelectData,
					CampaignsIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CampaignsIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...campaignsIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::index */
export function useCampaignsIndexSuspense<TSelectData = CampaignsIndexResponse>(
	params?: CampaignsIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CampaignsIndexResponse,
					AxiosError<CampaignsIndexError>,
					TSelectData,
					CampaignsIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CampaignsIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...campaignsIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
